import { jwtDecode } from "jwt-decode";

export const lastPage = (name) => {
    const page = localStorage.getItem(`${name}_page`);
    return page !== null ? Number(page) : 0;
};
export const saveLastPage = (name, paginationData) => {
    const page =
        Number.isInteger(paginationData?.number)
            ? paginationData.number
            : lastPage(name);

    localStorage.setItem(`${name}_page`, page >= 0 ? page : 0);
};

export const saveLastUrl = () => {
    const user = loggedInUserDetails();
    localStorage.setItem(`${user.sub}_lastUrl`, window.location.pathname + window.location.search); // save last page
}

export const loggedInUserDetails = () => {
    const token = localStorage.getItem("token");
    if (token) {
        return jwtDecode(token);
    }
    return null;
}

export const simpleDateFormatter = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export const getLastMonthRange = (date = new Date()) => {
    const d = new Date(date);

    // Start of last month
    const start = new Date(d.getFullYear(), d.getMonth() - 1, 1);

    // End of last month
    const end = new Date(d.getFullYear(), d.getMonth(), 0);

    const format = (dt) => {
        const year = dt.getFullYear();
        const month = String(dt.getMonth() + 1).padStart(2, "0");
        const day = String(dt.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    return {
        startDate: format(start),
        endDate: format(end),
    };
};

export const makePageableData = (totalDataCount, size, page, elements) => {
    const totalPages = Math.ceil(totalDataCount / size);
    return {
        number: page,
        first: page === 0,
        last: totalPages === (page + 1),
        numberOfElements: elements,
        totalElements: totalDataCount,
        totalPages: totalPages
    };
}

export const validateField = (input, specialCharter = false, numbers = false) => {
    // Check empty
    if (!input || input.trim() === "") {
        return { status: false, message: "Field cannot be empty" };
    }
    // check for limit
    if (input.length > 100) {
        return {
            status: false,
            message: "Maximum 100 characters allowed"
        };
    }


    // Only alphanumeric (ASCII letters + numbers) Restrict: Special Symbol
    if (specialCharter) {
        const alphanumericRegex = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
        if (!alphanumericRegex.test(input)) {
            return {
                status: false,
                message: "Only alphanumeric characters (A-Z, a-z, 0-9) are allowed. No special characters, Before/After spaces, emojis, or symbols."
            };
        }
    }

    // Reject only numbers
    if (numbers) {
        const onlyNumbersRegex = /^[0-9]+$/;
        if (onlyNumbersRegex.test(input)) {
            return {
                status: false,
                message: "Field cannot contain only numbers. Include at least one letter."
            };
        }
    }


    return {
        status: true,
        message: true
    };
}

export const validateUrl = (input, urlType) => {
    if (!input || input.trim() === "") {
        return { status: false, message: "Field cannot be empty" };
    }

    if (input.length > 500) {
        return {
            status: false,
            message: "Maximum 500 characters allowed in url"
        };
    }

    // Split multiple URLs (even concatenated)
    const urls = input.split(/(?=https?:\/\/)/g);

    if (urls.length !== 1) {
        return {
            status: false,
            message: "Multiple URLs detected. Only one URL is allowed."
        };
    }

    const url = urls[0].trim();

    // Basic URL validation with managing space
    const urlRegex = /^https?:\/\/[^\s]+$/;
    if (!urlRegex.test(url)) {
        return {
            status: false,
            message: "Invalid URL format"
        };
    }

    const cleanUrl = url.split("?")[0].toLowerCase();

    const imageRegex = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/;
    const videoRegex = /\.(mp4|webm|ogg|mov|m4v|avi|mkv)$/;

    const isImage = imageRegex.test(cleanUrl);
    const isVideo = videoRegex.test(cleanUrl);

    // Validate based on urlType
    if (urlType === "image") {
        if (!isImage) {
            return {
                status: false,
                message: "URL must be a valid image (jpg, png, gif, etc.)"
            };
        }
    }

    if (urlType === "video") {
        if (!isVideo) {
            return {
                status: false,
                message: "URL must be a valid video (mp4, webm, etc.)"
            };
        }
    }

    return {
        status: true,
        message: true
    };
}


const MyComponent = () => { };
export default MyComponent;